import { getRouteApi } from '@tanstack/react-router';
import TableWithThumbnails from '~/components/TableWithThumbnails';
import TabSwitch from '~/partials/TabSwitch';
import { TabsContent } from '~/primitives/tabs';
import { ClanLevelRecordsDialog } from './-ClanLevelRecordsDialog';
import { useState } from 'react';
import { BaseLevel } from '~/util/types/levels';
import { CountryClanProfileResolvedRecord } from '~/util/types/profiles';

const Route = getRouteApi('/profile/clan/$clanid');

function ClanProfileMain() {
    const { profile, total } = Route.useLoaderData({
        select: ({ profile, total }) => ({
            profile,
            total,
        }),
    });
    const navigate = Route.useNavigate();
    const { tab } = Route.useSearch({ select: ({ tab }) => ({ tab }) });

    const created = profile.created.filter(
        (level) => level.status != 'Removed',
    );
    const records = profile.records.filter(
        (record) => record.level.status != 'Removed',
    );

    const [clanLevelRecordsDialogOpen, setClanLevelRecordsDialogOpen] =
        useState(false);
    const [selectedLevel, setSelectedLevel] = useState<BaseLevel | null>(null);

    return (
        <section className="w-full p-2 lg:px-8 lg:w-4/6 text-justify">
            <TabSwitch
                onChange={(tab) => {
                    navigate({
                        search: ({ list }) => ({
                            tab,
                            list,
                        }),
                        replace: true,
                    });
                }}
                current={tab}
                options={['completed', 'created']}
                optionsDisplay={[
                    `Completed (${total})`,
                    `Created (${created?.length ?? 0})`,
                ]}
                size="sm"
            >
                <TabsContent
                    value="completed"
                    className="w-full h-[calc(100vh-240px)]"
                >
                    {records.length > 0 ? (
                        <TableWithThumbnails
                            data={records}
                            showMobile
                            showCompletionLink
                            enableSearch
                            enableSort
                            showPoints
                            showUserLink
                            onRowClick={(data) => {
                                setSelectedLevel(
                                    (data as CountryClanProfileResolvedRecord)
                                        .level,
                                );
                                setClanLevelRecordsDialogOpen(true);
                            }}
                        />
                    ) : (
                        <p className="my-6 italic opacity-50 text-center">
                            No players in this clan have any records.
                        </p>
                    )}
                </TabsContent>
                <TabsContent
                    value="created"
                    className="w-full h-[calc(100vh-240px)]"
                >
                    {created.length > 0 ? (
                        <TableWithThumbnails
                            data={created}
                            showUserLink
                            enableSearch
                        />
                    ) : (
                        <p className="my-6 italic opacity-50 text-center">
                            No players in this clan have published or created
                            any Extreme Demons.
                        </p>
                    )}
                </TabsContent>
            </TabSwitch>
            {selectedLevel && (
                <ClanLevelRecordsDialog
                    level={selectedLevel}
                    open={clanLevelRecordsDialogOpen}
                    onOpenChange={setClanLevelRecordsDialogOpen}
                />
            )}
        </section>
    );
}

export default ClanProfileMain;
